import { useEffect, useState } from "react";
import "./UKETSReportSummary.scss";
import { useSelector } from "react-redux";
import { roundOff } from "../../../../../../../services/utilities";
import { accessAPIForResponse } from "../../../../../../../services/api-services/api-implementations";
import Loader from "../../../../../../../common/Loader/Loader";

const UKETSReportSummary = () => {
  const user = useSelector((state) => state.userInfo.userData);
  const reportDetails = useSelector(
        (state) => state.reports.selectedReportDetails
    );
  const roles = user?.roles || [];
  const showComparisionData=roles.includes("ER_REVIEWER") || roles.includes("ER_VERIFIER") || roles.includes("ER_SUPERADMIN")
  
  const [reportSummaryData,setReportSummaryData]=useState(null);
  const [isCollapsed, setIsCollapsed] = useState({
    "vessel": false,
    "monitoringMethods": false,
    "fuelsConsumed": false,
    "maritimeEmissions": false,
    "comparision": false
  });
  const [isLoading, setIsLoading] = useState(false);

  const UKETSReportSummary_Sections = {
    "vessel": "Vessel Information",
    "monitoringMethods": "38 - (1) (a) (iv) Information on each monitoring method used and the associated level of uncertainty",
    "fuelsConsumed": "38 - (1) (a) (v) Total amount of each type of fuel consumed",
    "comparision":"Total Fuel Consumption, Distance, and Time",
    "maritimeEmissions": "Maritime Emissions"
  }

  const getReportSummaryData = async () => {
    setIsLoading(true);
    try {
      const response = await accessAPIForResponse("GetUkEtsReportSummary", null, [reportDetails?.ReportMstId]);
      console.log("GetUkEtsReportSummary response:", response);
      if (response) {
        setReportSummaryData(
          {
            ...response,
          fuelConsumptions: response?.fuelConsumptions?.filter((fuel) => fuel.fuelConsumption!==0)
        }
        )
      }
    } catch (error) {
      console.error("Error fetching verify engineers:", error);
      return;
    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getReportSummaryData();
  }, [])

  const toggleCollapse = (type) => {
    setIsCollapsed({
      ...isCollapsed,
      [type]: !isCollapsed[type]
    }
    );
  };

  const vesselTable = () => {
    return (
      <table className="m-4">
        <tbody>
          <tr>
            <td className="fw-bold">38 - (1) (a) (i)</td>
            <td className="fw-bold">Name of Ship</td>
            <td>{reportSummaryData?.vesselName}</td>
          </tr>
          <tr>
            <td className="fw-bold">38 - (1) (a) (ii)</td>
            <td className="fw-bold">IMO Ship Identification Number</td>
            <td>{reportSummaryData?.imoShipIdentificationNumber}</td>
          </tr>
          <tr>
            <td className="fw-bold">38 - (1) (a) (iii)</td>
            <td className="fw-bold">Flag State and the State of Registration of the bareboat charter</td>
            <td>{reportSummaryData?.flagStateAndRegistration}</td>
          </tr>
        </tbody>
      </table>
    )
  }

  const monitoringMethodTable = () => (
    <table className="m-4">
      <thead>
        <tr>
          <th>Vessel Consumer</th>
          <th>Monitoring Method</th>
          <th>Level of Uncertainty +/- (%)</th>
        </tr>
      </thead>
      <tbody>
        {reportSummaryData?.monitoringMethods && reportSummaryData.monitoringMethods.length > 0 ? reportSummaryData.monitoringMethods.map((consumer) => (
          <tr>
            <td>{consumer?.vesselConsumer}</td>
            <td>{consumer?.monitoringMethod}</td>
            <td title={consumer?.levelOfUncertainty}>{roundOff(consumer?.levelOfUncertainty,5,5)}</td>
          </tr>
        )):
        <tr>
        <td
          colSpan={3}
          className="no-records"
          style={{ fontStyle: "italic" }}
        >
          No records to display
        </td>
      </tr>}
      </tbody>
    </table>
  )

  const fuelTable = () => (
    <table className="m-4">
      <thead>
        <tr>
          <th>Fuel No.</th>
          <th>Fuel ID</th>
          <th>Fuel Name</th>
          <th>UK ETS EF CO2</th>
          <th>UK ETS EF CH4</th>
          <th>UK ETS EF N2O</th>
          <th>Fuel Consumption (MT)</th>
        </tr>
      </thead>
      <tbody>
        {reportSummaryData?.fuelConsumptions && reportSummaryData.fuelConsumptions.length > 0 ? reportSummaryData.fuelConsumptions.map((fuelData, idx) => (
          <tr>
            <td>{idx+1}</td>
            <td>{fuelData?.fuelId}</td>
            <td>{fuelData?.fuelName}</td>
            <td title={fuelData?.ukEtsEfCo2}>{roundOff(fuelData?.ukEtsEfCo2, 5, 5)}</td>
            <td title={fuelData?.ukEtsEfCh4}>{roundOff(fuelData?.ukEtsEfCh4, 5, 5)}</td>
            <td title={fuelData?.ukEtsEfN2o}>{roundOff(fuelData?.ukEtsEfN2o, 5, 5)}</td>
            <td title={fuelData?.fuelConsumption}>{roundOff(fuelData?.fuelConsumption, 5, 5)}</td>
          </tr>
        )) : (
          <tr>
            <td
              colSpan={7}
              className="no-records"
              style={{ fontStyle: "italic" }}
            >
              No records to display
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )

  const comparisionTable=()=>(
    <div>
      <table className="m-4">
        <thead>
          <tr>
            <th></th>
            <th>Reported</th>
            {showComparisionData && <th>Calculated</th>}
            {showComparisionData && <th>% Diff</th>}
            {showComparisionData && <th>5% Materiality</th>}
          </tr>
        </thead>
        <tbody>
          {reportSummaryData?.totalFuelConsumption && <tr>
            <td className="fw-bold">Total Fuel Consumption(MT)</td>
            <td title={reportSummaryData?.totalFuelConsumption?.reported}>{roundOff(reportSummaryData?.totalFuelConsumption?.reported, 5, 5)}</td>
              {showComparisionData && <td title={reportSummaryData?.totalFuelConsumption?.calculated}>{roundOff(reportSummaryData?.totalFuelConsumption?.calculated, 5, 5)}</td>}
              {showComparisionData && <td title={reportSummaryData?.totalFuelConsumption?.percentageDifference}>{roundOff(reportSummaryData?.totalFuelConsumption?.percentageDifference, 5, 5)}</td>}
              {showComparisionData && <td title={reportSummaryData?.totalFuelConsumption?.materiality5Percent}>{roundOff(reportSummaryData?.totalFuelConsumption?.materiality5Percent, 5, 5)}</td>}
          </tr>}
          {reportSummaryData?.distanceTravelled && <tr>
            <td className="fw-bold">Distance Travelled(nm)</td>
            <td title={reportSummaryData?.distanceTravelled?.reported}>{roundOff(reportSummaryData?.distanceTravelled?.reported, 5, 5)}</td>
              {showComparisionData && <td title={reportSummaryData?.distanceTravelled?.calculated}>{roundOff(reportSummaryData?.distanceTravelled?.calculated, 5, 5)}</td>}
              {showComparisionData && <td title={reportSummaryData?.distanceTravelled?.percentageDifference}>{roundOff(reportSummaryData?.distanceTravelled?.percentageDifference, 5, 5)}</td>}
              {showComparisionData && <td title={reportSummaryData?.distanceTravelled?.materiality5Percent}>{roundOff(reportSummaryData?.distanceTravelled?.materiality5Percent, 5, 5)}</td>}
          </tr>}
          {reportSummaryData?.timeAtSea && <tr>
            <td className="fw-bold">Time at sea(h)</td>
            <td title={reportSummaryData?.timeAtSea?.reported}>{roundOff(reportSummaryData?.timeAtSea?.reported, 5, 5)}</td>
              {showComparisionData && <td title={reportSummaryData?.timeAtSea?.calculated}>{roundOff(reportSummaryData?.timeAtSea?.calculated, 5, 5)}</td>}
              {showComparisionData && <td title={reportSummaryData?.timeAtSea?.percentageDifference}>{roundOff(reportSummaryData?.timeAtSea?.percentageDifference, 5, 5)}</td>}
              {showComparisionData && <td title={reportSummaryData?.timeAtSea?.materiality5Percent}>{roundOff(reportSummaryData?.timeAtSea?.materiality5Percent, 5, 5)}</td>}
          </tr>}
          {reportSummaryData?.timeAtSea==null && reportSummaryData?.distanceTravelled==null && reportSummaryData?.totalFuelConsumption==null && <tr>
            <td
              colSpan={5}
              className="no-records"
              style={{ fontStyle: "italic" }}
            >
              No records to display
            </td>
          </tr>}
        </tbody>
      </table>
    </div>
  )

  const maritimeEmissionsTable = () => (
    <div>
      <table className="m-4">
        <thead>
          <tr>
            <th></th>
            <th style={{ width: "10%" }}></th>
            <th>CO2 ETS</th>
            <th>CH4 ETS</th>
            <th>N2O ETS</th>
            <th>ME ETS</th>
          </tr>
        </thead>
        <tbody>
          {reportSummaryData?.inPortActivitiesEmissions && (
            <tr>
              <td className="fw-bold">38 - (1) (a) (vi)</td>
              <td className="fw-bold">Aggregated maritime emissions from all in-port activities</td>
              <td title={reportSummaryData?.inPortActivitiesEmissions?.co2Ets}>{roundOff(reportSummaryData?.inPortActivitiesEmissions?.co2Ets, 5, 5)}</td>
              <td title={reportSummaryData?.inPortActivitiesEmissions?.ch4Ets}>{roundOff(reportSummaryData?.inPortActivitiesEmissions?.ch4Ets, 5, 5)}</td>
              <td title={reportSummaryData?.inPortActivitiesEmissions?.n2oEts}>{roundOff(reportSummaryData?.inPortActivitiesEmissions?.n2oEts, 5, 5)}</td>
            <td title={reportSummaryData?.inPortActivitiesEmissions?.meEts}>{roundOff(reportSummaryData?.inPortActivitiesEmissions?.meEts, 5, 5)}</td>
          </tr>)}
          {reportSummaryData?.voyagesOtherThanSub && (
            <tr>
              <td className="fw-bold">38 - (1) (a) (vii)</td>
              <td className="fw-bold">Aggregated maritime emissions from all voyages other than those in sub paragraph (viii)</td>
              <td title={reportSummaryData?.voyagesOtherThanSub?.co2Ets}>{roundOff(reportSummaryData?.voyagesOtherThanSub?.co2Ets, 5, 5)}</td>
              <td title={reportSummaryData?.voyagesOtherThanSub?.ch4Ets}>{roundOff(reportSummaryData?.voyagesOtherThanSub?.ch4Ets, 5, 5)}</td>
              <td title={reportSummaryData?.voyagesOtherThanSub?.n2oEts}>{roundOff(reportSummaryData?.voyagesOtherThanSub?.n2oEts, 5, 5)}</td>
            <td title={reportSummaryData?.voyagesOtherThanSub?.meEts}>{roundOff(reportSummaryData?.voyagesOtherThanSub?.meEts, 5, 5)}</td>
          </tr>)}
          {reportSummaryData?.voyagesBetweenGINI && (
            <tr>
              <td className="fw-bold">38 - (1) (a) (viii)</td>
              <td className="fw-bold">Aggregated maritime emissions from all voyages between Great Britain and Northern Ireland</td>
              <td title={reportSummaryData?.voyagesBetweenGINI?.co2Ets}>{roundOff(reportSummaryData?.voyagesBetweenGINI?.co2Ets, 5, 5)}</td>
              <td title={reportSummaryData?.voyagesBetweenGINI?.ch4Ets}>{roundOff(reportSummaryData?.voyagesBetweenGINI?.ch4Ets, 5, 5)}</td>
              <td title={reportSummaryData?.voyagesBetweenGINI?.n2oEts}>{roundOff(reportSummaryData?.voyagesBetweenGINI?.n2oEts, 5, 5)}</td>
            <td title={reportSummaryData?.voyagesBetweenGINI?.meEts}>{roundOff(reportSummaryData?.voyagesBetweenGINI?.meEts, 5, 5)}</td>
          </tr>)}
          {reportSummaryData?.totalMaritimeEmissions && (
            <tr>
              <td className="fw-bold">38 - (1) (a) (ix)</td>
              <td className="fw-bold">Total aggregated maritime emissions from all maritime activities</td>
              <td title={reportSummaryData?.totalMaritimeEmissions?.co2Ets}>{roundOff(reportSummaryData?.totalMaritimeEmissions?.co2Ets, 5, 5)}</td>
              <td title={reportSummaryData?.totalMaritimeEmissions?.ch4Ets}>{roundOff(reportSummaryData?.totalMaritimeEmissions?.ch4Ets, 5, 5)}</td>
              <td title={reportSummaryData?.totalMaritimeEmissions?.n2oEts}>{roundOff(reportSummaryData?.totalMaritimeEmissions?.n2oEts, 5, 5)}</td>
            <td title={reportSummaryData?.totalMaritimeEmissions?.meEts}>{roundOff(reportSummaryData?.totalMaritimeEmissions?.meEts, 5, 5)}</td>
          </tr>)}
          {reportSummaryData?.inPortActivitiesEmissions==null && reportSummaryData?.voyagesOtherThanSub==null && reportSummaryData?.voyagesBetweenGINI==null && reportSummaryData?.totalMaritimeEmissions==null && <tr>
            <td
              colSpan={6}
              className="no-records"
              style={{ fontStyle: "italic", }}

            >
              No records to display
            </td>
          </tr>}
        </tbody>
      </table>
    </div>
  )

  return (
    isLoading ? <Loader /> :
    <div className="ukets-report-summary">
      {
        Object.entries(UKETSReportSummary_Sections).map(([key, value], idx) => {
          return <div className={`section ${key}-section mt-4`} key={`${key}-section`}>
            <h5
              onClick={() => toggleCollapse(key)}
              className="title"
            >
              {isCollapsed[key] ? " + " : " - "} &nbsp;&nbsp; {value}
            </h5>
            {!isCollapsed[key] && (
              idx == 0 ? vesselTable() :
                idx == 1 ? monitoringMethodTable() :
                  idx == 2 ? fuelTable() :
                  idx == 3 ? comparisionTable() :
                    maritimeEmissionsTable()
            )}
          </div>
        }
        )}
    </div>
  );
}

export default UKETSReportSummary;